<template>
    <div class="container-fluid mb-5 ps-5">
        <div class="row">
            <div class="col">
                <img @click="$emit('go-back-event')" src="../../assets/back-button.svg" class="img-fluid cursor-pointer" width="32" alt="">
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col text-center">
                <h1 class="thin-text mb-5 fs-3">A chi è rivolto il risparmio finalizzato?</h1>
            </div>
        </div>
    </div>
    <div class="custom-container">
        <form @submit.prevent="validateForm" id="formId" method="post" novalidate="true">
            <div class="row mb-5">
                <div class="col-lg-3">
                    <label class="custom-radio">
                        <input v-model="formData.personType" type="radio" name="person" id="Figlio/a" value="Figlio/a" required>
                        <img class="mb-3" src="../../assets/rivolto-screen/figlio.png" alt="">
                        <span class="thin-text">Figlio/a</span>
                    </label>
                </div>
                <div class="col-lg-3">
                    <label class="custom-radio">
                        <input v-model="formData.personType" type="radio" name="person" id="Nipote" value="Nipote" required>
                        <img class="mb-3" src="../../assets/rivolto-screen/nipote.png" alt="">
                        <span class="thin-text">Nipote</span>
                    </label>
                </div>
                <div class="col-lg-3">
                    <label class="custom-radio">
                        <input v-model="formData.personType" type="radio" name="person" id="Parente" value="Parente" required>
                        <img class="mb-3" src="../../assets/rivolto-screen/parente.png" alt="">
                        <span class="thin-text">Parente</span>
                    </label>
                </div>
                <div class="col-lg-3">
                    <label class="custom-radio">
                        <input  v-model="formData.personType" type="radio" name="person" id="Padrino" value="Padrino" required>
                        <img class="mb-3" src="../../assets/rivolto-screen/padrino.png" alt="">
                        <span class="thin-text">Persona cara</span>
                    </label>
                </div>
            </div>
            
            <div class="row mb-3">
                <div class="col-sm-6">
                    <input v-model="formData.firstName" type="text" class="form-control" id="firstName" placeholder="Nome" required="" >
                </div>

                <div class="col-sm-6">
                    <input v-model="formData.dateOfBirth" :type="formData.dateOfBirth == null ? 'text' : 'date'" class="form-control" id="dob" placeholder="Data di nascita" onfocus="(this.type='date')"  required=""> 
                </div>
            </div>
            <div class="text-center mb-3">
                <input type="submit" value="Procedi">
            </div>
        </form>

    </div>
    <div class="container" v-if="this.errors.length > 0">
        <div class="row">
            <ul class="list-unstyled col-lg-6 offset-3">
                <li class="alert alert-danger p-2 mb-1" role="alert" :key="key" v-for="(error, key) in this.errors">
                    {{error}}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ToWhomScreen',
        emits: ['go-to-event', 'go-back-event', 'save-form-data-event'],
        props: {
            formData: {
                type: Object,
                default(rawProps) {
                    return {
                        personType: null,
                        firstName: null,
                        dateOfBirth: null,
                    }
                }
            }
            
        },
        data() {
            return {
                errors: []
            }
        },
        methods: {
            validateForm() {
                if (this.formData.personType && this.formData.firstName && this.formData.dateOfBirth) {
                    // console.log('Saved Form Data');
                    this.$emit('save-form-data-event', this.formData);
                    this.$emit('go-to-event', 'RealizeScreenId');
                    return true;
                }
                this.errors = [];
                if (!this.formData.personType) {
                    this.errors.push("A chi è rivolto mancante");
                }
                if (!this.formData.firstName || this.formData.firstName == "") {
                    this.errors.push("Nome mancante");
                }
                if (!this.formData.dateOfBirth  || this.formData.dateOfBirth == "") {
                    this.errors.push("Data di nascita mancante");
                }
            }
        }
    }
</script>